import { __ } from '@wordpress/i18n';
import {Panel, PanelBody, PanelRow, TextControl, Button, TextareaControl, ToggleControl, RadioControl, ToolbarButton, ToolbarGroup } from "@wordpress/components"
import { Image, MediaToolbar } from "@10up/block-components"
import { MediaUpload, MediaUploadCheck, useBlockProps, useBlockEditContext, BlockControls, InspectorControls, RichText, URLPopover} from "@wordpress/block-editor"
import { registerBlockType } from "@wordpress/blocks"
import { useState, useEffect } from '@wordpress/element';
import apiFetch from '@wordpress/api-fetch';
import metadata from "./block.json"


import 'bootstrap/dist/css/bootstrap-grid.min.css';
import "./index.scss"


registerBlockType(metadata.name, {...metadata, edit: EditComponent })

function EditComponent(props) {

  const {attributes, setAttributes}= props;
  const {categorias, titulo} = attributes;


  const [isURLPopoverVisible, setURLPopoverVisible] = useState(false);
  const [selectedURL, setSelectedURL] = useState('');
  const [postLinks, setPostLinks] = useState([]);
  const [pageLinks, setPageLinks] = useState([]);
  const [formacoesLinks, setFormacoesLinks] = useState([]);


  const setCategoriaSlug= (index, slug) => {
    const newCategorias = [...categorias];
    newCategorias[index] = {...newCategorias[index], slug: slug};
    setAttributes({categorias: newCategorias});
  }

  const setCategoriaNome= (index, nome) => {
    const newCategorias = [...categorias];
    newCategorias[index] = {...newCategorias[index], nome: nome};
    setAttributes({categorias: newCategorias});
  }

  const setCategoriaSlugTax= (index, slug_tax) => {
    const newCategorias = [...categorias];
    newCategorias[index] = {...newCategorias[index], slug_tax: slug_tax};
    setAttributes({categorias: newCategorias});
  }

  const setCategoriaImage= (index, imagem) => {
    const newCategorias = [...categorias];
    newCategorias[index] = {...newCategorias[index], id: imagem.id, url: imagem.url};
    setAttributes({categorias: newCategorias});
  }

  const setCategoriaLink= (index, link) => {
    const newCategorias = [...categorias];
    newCategorias[index] = {...newCategorias[index], link: link};
    setAttributes({categorias: newCategorias});
  }


  const addCategoria = () => {
    const newCategorias = [...categorias, { slug: "", nome: "", slug_tax: "", id: null, url: null, link: ""}];
    setAttributes({ categorias: newCategorias });
  }


  const handleCategoriaRemove = (index) => {
    const newCategorias = [...categorias];
    newCategorias.splice(index, 1);
    setAttributes({categorias: newCategorias});
  }



  const moveCategoriasLeft = (index) => {
    if (index === 0) return;
    const newCategorias = [...categorias];
    const temp = newCategorias[index - 1];
    newCategorias[index - 1] = newCategorias[index];
    newCategorias[index] = temp;
    setAttributes({ categorias: newCategorias });
  }

  const moveCategoriasRight = (index) => {
    if (index === categorias.length - 1) return;
    const newCategorias = [...categorias];
    const temp = newCategorias[index + 1];
    newCategorias[index + 1] = newCategorias[index];
    newCategorias[index] = temp;
    setAttributes({ categorias: newCategorias });
  }


  return (
    <>
      <div {...useBlockProps()}>
        <div className="container-fluid px-0 pt-5">
          <div className="row mx-0 g-0">
            <div className="col-lg-12">
              <h2 className="text-center mb-5">
                <TextControl
                  label="Título do Catálogo"
                  value={titulo}
                  onChange={(e) => setAttributes({ titulo: e })}
                />
              </h2>
              <div className="row">
                {categorias.map((categoria, index) => (
                  <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={index}>
                    <div className="category-item">
                    <ToolbarGroup>
                          <ToolbarButton
                            icon="arrow-left-alt2"
                            label={__('Move Left', 'text-domain')}
                            onClick={() => moveCategoriasLeft(index)}
                            disabled={index === 0} />
                          <ToolbarButton
                            icon="arrow-right-alt2"
                            label={__('Move Right', 'text-domain')}
                            onClick={() => moveCategoriasRight(index)}
                            disabled={index === categorias.length - 1} />
                    </ToolbarGroup>
                    <br /><br /><br />
                    <br /><br /><br />
                        
                      <MediaUploadCheck>
                          <MediaUpload
                            onSelect={(imagem) => setCategoriaImage(index, imagem)}
                            allowedTypes={['image']}
                            value={categoria.id}
                            render={({ open }) => (
                              <Button onClick={open}>
                                {categoria.url ? (
                                  <img src={categoria.url} alt={__('Image', 'text-domain')} style={{ maxWidth: '100%' }} />
                                ) : (
                                  __('Upload Image', 'text-domain')
                                )}
                              </Button>
                            )} />
                        </MediaUploadCheck>
                      <div className="overlay"></div>
                      <div className="content">
                        <TextControl
                          label={__('Nome da Categoria')}
                          value={categoria.nome}
                          onChange={(e) => setCategoriaNome(index, e)}
                        />
                        {/* <TextControl
                          label={__('Slug da Categoria')}
                          value={categoria.slug}
                          onChange={(e) => setCategoriaSlug(index, e)}
                        />
                        <TextControl
                          label={__('Slug da Taxonomia')}
                          value={categoria.slug_tax}
                          onChange={(e) => setCategoriaSlugTax(index, e)}
                        /> */}
                        <TextControl
                          label={__('Link')}
                          value={categoria.link}
                          onChange={(e) => setCategoriaLink(index, e)}
                        />
                      </div>
                      <Button isDestructive onClick={() => handleCategoriaRemove(index)}>Remover Categoria</Button>
                    </div>
                  </div>
                ))}
              </div>
              <Button isPrimary onClick={addCategoria}>Adicionar Categoria</Button>
            </div>
          </div>
        </div>






      {/* <div id="child">
        <h2> Editar Catálogo</h2>

        <h5>Título do Catálogo</h5>

        <TextControl
              value={ titulo }
              onChange={(e) => setAttributes({ titulo: e })} />

        <br></br>

        <InspectorControls>
          <PanelBody title={('Settings', 'Categorias')}>
          {categorias.map((categoria, index) => (
            <PanelBody title={`Categoria ${index + 1}`}>
              <PanelRow key={index}>
                <div>
                <TextControl
                      label={('Nome da Categoria')}
                      value={ categoria.nome }
                      onChange={(e) => setCategoriaNome(index, e)}
                    />
                  <TextControl
                      label={('Slug da Categoria')}
                      value={ categoria.slug }
                      onChange={(e) => setCategoriaSlug(index, e)}
                    />
                  <ul>
                    <li>
                      <CustomMediaToolbar
                      id={categoria.id}
                      onSelect={(imagem) => setCategoriaImage(index, imagem)}
                    />
                    </li>
                    <li>
                    <Image
                      id={categoria.id}
                      size="full"
                      onSelect={(imagem) => setCategoriaImage(index, imagem)}
                    />
                    </li>
                  </ul>
                  <Button isDestructive onClick={() => handleCategoriaRemove(index)}>Remover Categoria</Button>
                </div>
              </PanelRow>
              </PanelBody>
            ))}
            <PanelRow>
              <Button isPrimary onClick={addCategoria}>Adicionar Categoria</Button>
            </PanelRow>
          </PanelBody>
        </InspectorControls> 

        
        </div>*/}
      </div>
  </>
  )
}